import * as React from "react";
import * as S from "@styled";
import styled from "styled-components";
import theme from "styled-theming";

import { ThemeType } from "shared/styles/theme";

interface INotificationBell {
    animate: boolean;
}

const notificationBellDotStrokeColor = theme("mode", {
    [ThemeType.light]: S.Colors.white,
    [ThemeType.dark]: S.Colors.dark3,
});

const notificationBellDotFillColor = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.white,
});

const StyledNotificationBell = styled.div<INotificationBell>`
    position: relative;
    width: 24px;
    height: 24px;
    
    i {
        position: absolute;
        top: 0;
        left: 0;
        font-size: var(--header-2-font-size);
    }

    svg {
        position: absolute;
        right: 2px;
        width: 10px;
        height: 10px;
        opacity: 0;
        transform: scale(0.2);

        circle {
            stroke: ${notificationBellDotStrokeColor};
            fill: ${notificationBellDotFillColor};
        }
    }

    @keyframes dot-animation {
        0% {
            opacity: 0;
            transform: scale(0.2);
        }
        20% {
            opacity: 1;
        }
        42% {
            opacity: 1;
            transform: scale(1.1);
        }
        62% {
            opacity: 1;
            transform: scale(1);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    ${({ animate }) => animate && `
        svg {
            animation: dot-animation 1s linear 0s infinite;
        }
    `}

`;

const NotificationBell: React.FC<INotificationBell> = ({ animate }) => (
    <StyledNotificationBell
        id="navigation-changelog-bell"
        animate={animate}
    >
        <i className="ci-notification_outline" />
        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="4" strokeWidth="2" />
        </svg>
    </StyledNotificationBell>
);

export default NotificationBell;
